import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=ae7e65c8&scoped=true"
import script from "./DetailBox.vue?vue&type=script&lang=js"
export * from "./DetailBox.vue?vue&type=script&lang=js"
import style0 from "./DetailBox.vue?vue&type=style&index=0&id=ae7e65c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7e65c8",
  null
  
)

export default component.exports